import { Chip, TableCell, TableRow } from "@mui/material";
import {
  RowStyled,
  TableBodyStyled,
  TableCellStyled,
  TableHeadStyled,
  TableStyled,
  TooltipStyled,
} from "../../shared/styles";
import { ClipLoader } from "react-spinners";
import { formatLargeText, formatTimeUnix } from "../../shared/utils";

export const TablePayoneerTransactions = ({
  transactions,
  isLoadingTransactions,
  isErrorTransactions,
}) => {
  return (
    <TableStyled>
      <TableHeadStyled>
        <TableRow>
          <TableCell align="center">Signature</TableCell>
          <TableCell align="center">Status</TableCell>
          <TableCell align="center">Date</TableCell>
          <TableCell align="center">Sender</TableCell>
          <TableCell align="center">Receiver</TableCell>
          <TableCell align="center">Amount</TableCell>
        </TableRow>
      </TableHeadStyled>
      <TableBodyStyled>
        {isLoadingTransactions ? (
          <TableRow>
            <TableCell colSpan={6} align="center">
              <ClipLoader loading={true} size={24} color="#0197f6" />
            </TableCell>
          </TableRow>
        ) : transactions?.length ? (
          transactions?.map((row) => (
            <RowStyled
              key={row.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCellStyled align="center">
                <TooltipStyled title={row.signature || "-"}>
                  {formatLargeText(row.signature || "-", 40)}
                </TooltipStyled>
              </TableCellStyled>
              <TableCellStyled align="center">
                <Chip
                  label={row.status || "-"}
                  sx={{
                    color: row.status === "finalized" ? "#118FF0" : "#FF0000",
                    fontWeight: "bold",
                    fontSize: "12px",
                    borderRadius: "8px",
                    border: `1px solid ${
                      row.status === "finalized" ? "#118FF0" : "#FF0000"
                    }`,
                    backgroundColor: "#F5F5F5",
                  }}
                />
              </TableCellStyled>
              <TableCellStyled align="center">
                {formatTimeUnix(row.blockTime)}
              </TableCellStyled>
              <TableCellStyled align="center">
                <TooltipStyled
                  title={
                    row?.transactionDetails?.transaction?.message
                      ?.accountKeys[0] || "-"
                  }
                >
                  {formatLargeText(
                    row?.transactionDetails?.transaction?.message
                      ?.accountKeys[0] || "-",
                    40
                  )}
                </TooltipStyled>
              </TableCellStyled>
              <TableCellStyled align="center">
                <TooltipStyled
                  title={
                    row?.transactionDetails?.transaction?.message
                      ?.accountKeys[1] || "-"
                  }
                >
                  {formatLargeText(
                    row?.transactionDetails?.transaction?.message
                      ?.accountKeys[1] || "-",
                    40
                  )}
                </TooltipStyled>
              </TableCellStyled>
              <TableCellStyled align="center">
                {(row?.transactionDetails?.metadata?.preBalances[0] -
                  row?.transactionDetails?.metadata?.postBalances[0] -
                  row?.transactionDetails?.metadata?.fee) /
                  1_000_000_000 +
                  " SOL"}
              </TableCellStyled>
            </RowStyled>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={6}>
              <h5>
                {isErrorTransactions
                  ? "Error al cargar las transacciones"
                  : "No hay información para mostrar"}
              </h5>
            </TableCell>
          </TableRow>
        )}
      </TableBodyStyled>
    </TableStyled>
  );
};
